import { SupportedChainId } from "constants/chains";

export const START_BLOCKS: { [key: string]: number } = {
  [SupportedChainId.MAINNET]: 8731665,
  [SupportedChainId.GOERLI]: 8731665,
  [SupportedChainId.XDC]: 59506303,
  [SupportedChainId.XDC_TESTNET]: 48352140
}